import { Injectable } from '@angular/core';
import { iBisEditService, iBisFileService, iBisLanguageService } from '@dohu/ibis-common';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { environment } from '../../../../../environments/environment';
import notify from 'devextreme/ui/notify';

@Injectable()

export class PatientListService extends iBisEditService {

    patientFiles: any;
    consultations: any;
    patientId: string = ''
    constructor(private entity: iBisEntityService, lg: iBisLanguageService, public file: iBisFileService) {
        super(lg);
        this.validation = null;
        this.title = 'PATIENT_LIST';
    }

    getById(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            resolve({});
        });
    }

    onRemove(id: string): Promise<void> {
        return new Promise((resolve) => { });
    }

    onSaveEv(): Promise<any> {
        return new Promise((resolve) => { });
    }

    reset(): void {
        this.model = {};
    }

    createDefault() {
        this.reset();
    }

    popupInit(ev: any) {
        super.popupInit(ev);
        ev.component.beginUpdate();
        ev.component.option('toolbarItems', []);
        ev.component.endUpdate();
    }

    getPatientFiles(patientId: any) {
        const appointments = new EntityQuery('Appointment').eq('patientId', patientId)
        appointments.fields.push('id');
        this.entity.store(appointments).load().then((app: any) => {
            const appIds = [];
            if (app.length > 0) {
                app.forEach((e: any) => { appIds.push(e.id); });
                const q = new EntityQuery('FileInfo').in('entityId', appIds).addOrderByDesc(['uploadTime']);

                this.entity.store(q, false, 'id', environment.saasServer).load().then((res: any) => {
                    this.patientFiles = res;
                }, err => notify(err, 'error', 3000));
            }
        });
    }

    getPatientFinishedAppointment(patientId: string) {
        const finishedApp = new EntityQuery('AppointmentView').eq('ap.patientId', patientId).eq('ap.statusId', 5);
        finishedApp.addOrderByDesc(['startDate'])
        return this.entity.store(finishedApp, false, 'ap_id').load().then((res: any) => {
            if (res.length > 0) {
                this.consultations = res;
            } else {
                this.consultations = [];
            }
        });
    }

}
